import axios from "axios";
import { createEventPayload, updateEventPayload } from "../../actions";

const majorEventsPath = "/major-events/v1";

const getUuid = (id: string) => {
  const parts = id.split("#");
  return parts[1] || parts[0]; // So this works with or without prefix on ID
};

export const createEvent = (payload: createEventPayload): any => {
  return axios.post(majorEventsPath, payload);
};

export const deleteEvent = (id: string): any => {
  return axios.delete(majorEventsPath + "/" + encodeURIComponent(getUuid(id)));
};

export const getEvents = (): any => {
  return axios.get(majorEventsPath);
};

export const getEvent = (id: string): any => {
  return axios.get(majorEventsPath + "/" + encodeURIComponent(getUuid(id)));
};

export const updateEvent = (id: string, payload: updateEventPayload): any => {
  return axios.put(majorEventsPath + "/" + encodeURIComponent(getUuid(id)), payload);
};
